import React from 'react';

export const fieldClass =
  'mt-2 w-full rounded-xl border border-black/15 bg-white px-4 py-3 text-sm outline-none transition focus:border-[var(--brand-primary,#4338ca)] focus:ring-2 focus:ring-[var(--brand-primary,#4338ca)]/15';
export const primaryButtonClass =
  'w-full rounded-xl bg-[var(--brand-primary,#4338ca)] px-4 py-3 text-sm font-semibold text-white transition hover:brightness-95 disabled:cursor-not-allowed disabled:opacity-60';

export const AuthPageShell: React.FC<{ title: string; lead: string; children: React.ReactNode }> = ({
  title,
  lead,
  children,
}) => (
  <main className="flex min-h-screen items-center justify-center bg-[#f7f8fb] px-5 py-10 text-[#0f172a]">
    <section className="w-full max-w-md rounded-3xl border border-black/10 bg-white p-8 shadow-xl shadow-black/5">
      <div className="mb-8">
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-[var(--brand-primary,#4338ca)]">
          dnam-ecrf
        </p>
        <h1 className="text-3xl font-semibold tracking-tight">{title}</h1>
        <p className="mt-2 text-sm leading-6 text-black/60">{lead}</p>
      </div>
      {children}
    </section>
  </main>
);
